import React from 'react';
import '../styles/Header.css';

const Header: React.FC = () => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-accent" />
        <h1 className="property-address">280 Tamarack Drive</h1>
        <p className="property-location">Ronald, WA</p>
      </div>
    </header>
  );
};

export default Header;
